import styled from 'styled-components';

import Badge from '@xcritical/badge';

import { colors } from '@crm-framework/theme';

export const NotificationBellWrapper = styled.div.attrs({
  className: 'notifications__bell',
})`
  position: relative;
`;

export const NotificationBellUnreadMessages = styled(Badge).attrs({
  className: 'notifications__bell-unread',
})`
  color: #fff;
  background-color: ${colors.R6};
  position: absolute;
  top: -5px;
  left: 15px;
`;
